/* ==========================================================================
   Fairway theme — theme.js
   Vanilla JS. No dependencies. Everything is wired via data attributes and
   event delegation, so re-rendered sections (cart drawer) need no rebinding.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.themeRoutes || { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart', search: '/search' };
  var moneyFormat = window.themeMoneyFormat || '${{amount}}';

  /* ---------- Utilities ---------- */

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var amountWithComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var amountNoDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amountNoDecimals);
  }

  /* ---------- Drawers ---------- */

  var overlay = null;
  var openDrawerEl = null;

  function getOverlay() {
    if (!overlay) overlay = document.querySelector('[data-drawer-overlay]');
    return overlay;
  }

  function openDrawer(name) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawers();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openDrawerEl = drawer;
    var ov = getOverlay();
    if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-open'); }); }
    document.body.classList.add('drawer-open');
    var focusable = drawer.querySelector('button, a, input, select');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    openDrawerEl = null;
    var ov = getOverlay();
    if (ov) {
      ov.classList.remove('is-open');
      setTimeout(function () { if (!openDrawerEl) ov.hidden = true; }, 300);
    }
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && window.themeCartType !== 'drawer') return; // fall through to /cart link
      e.preventDefault();
      openDrawer(name);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }
    if (e.target.closest('[data-drawer-overlay]')) { closeDrawers(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ---------- Sticky header (hide on scroll down, reveal on scroll up) ---------- */

  (function () {
    var headerSection = document.querySelector('.section-header');
    if (!headerSection) return;
    var lastY = window.scrollY;
    var ticking = false;

    function onScroll() {
      var y = window.scrollY;
      headerSection.classList.toggle('header-stuck', y > 4);
      if (y > 250 && y > lastY + 6) {
        headerSection.classList.add('header-hidden');
      } else if (y < lastY - 6 || y <= 250) {
        headerSection.classList.remove('header-hidden');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  })();

  /* ---------- Quantity steppers (event delegation) ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    var input = stepper && stepper.querySelector('input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    value = btn.hasAttribute('data-qty-plus') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart (AJAX) ---------- */

  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count-target]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function refreshCartDrawer(open) {
    return fetch(routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var existing = document.getElementById('CartDrawer');
        if (!existing) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('CartDrawer');
        if (fresh) {
          var wasOpen = existing.classList.contains('is-open');
          existing.innerHTML = fresh.innerHTML;
          var count = fresh.getAttribute('data-item-count');
          existing.setAttribute('data-item-count', count);
          updateCartCounts(count);
          if (wasOpen) existing.classList.add('is-open');
        }
        if (open) openDrawer('cart');
      });
  }

  function refreshCartPage() {
    var main = document.querySelector('[data-cart-page-section]');
    if (!main) return Promise.resolve();
    var sectionId = main.getAttribute('data-cart-page-section');
    return fetch(routes.cart + '?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-page-section]');
        if (fresh) main.innerHTML = fresh.innerHTML;
      });
  }

  function afterCartChange(openDrawerAfter) {
    return Promise.all([refreshCartDrawer(openDrawerAfter), refreshCartPage()])
      .then(function () {
        return fetch(routes.cart + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCounts(cart.item_count); });
      });
  }

  // Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (window.themeCartType !== 'drawer') return; // normal submit -> /cart
    e.preventDefault();
    var button = form.querySelector('[data-add-to-cart]');
    var originalText = button ? button.textContent : '';
    if (button) { button.setAttribute('disabled', ''); button.textContent = 'Adding...'; }
    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        return afterCartChange(true);
      })
      .catch(function (err) {
        var status = form.querySelector('[data-form-status]');
        if (status) { status.hidden = false; status.textContent = err.message; }
      })
      .finally(function () {
        if (button) { button.removeAttribute('disabled'); button.textContent = originalText; }
      });
  });

  // Line quantity change / removal (drawer + cart page)
  function changeLine(line, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return afterCartChange(false); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-line-qty]');
    if (!input) return;
    changeLine(parseInt(input.getAttribute('data-line-qty'), 10), parseInt(input.value, 10) || 0);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(parseInt(remove.getAttribute('data-line-remove'), 10), 0);
  });

  /* ---------- Product form: variant selection ---------- */

  function initProductForm(form) {
    var jsonEl = form.closest('[data-product]').querySelector('script[data-variants]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-add-to-cart]');
    var buttonText = button ? button.querySelector('[data-add-to-cart-text]') : null;
    var priceEl = form.closest('[data-product]').querySelector('[data-product-price]');

    function currentOptions() {
      var values = [];
      form.querySelectorAll('[data-option-index]').forEach(function (el) {
        if (el.tagName === 'SELECT') {
          values[parseInt(el.getAttribute('data-option-index'), 10)] = el.value;
        } else if (el.checked) {
          values[parseInt(el.getAttribute('data-option-index'), 10)] = el.value;
        }
      });
      return values;
    }

    function matchVariant(values) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function renderPrice(variant) {
      if (!priceEl || !variant) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' +
               '<span class="price__sale">' + formatMoney(variant.price) + '</span>';
      } else {
        html = '<span>' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    function onChange() {
      var variant = matchVariant(currentOptions());
      if (!variant) {
        if (button) {
          button.setAttribute('disabled', '');
          if (buttonText) buttonText.textContent = 'Unavailable';
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      renderPrice(variant);
      if (button) {
        if (variant.available) {
          button.removeAttribute('disabled');
          if (buttonText) buttonText.textContent = button.getAttribute('data-label-add') || 'Add to cart';
        } else {
          button.setAttribute('disabled', '');
          if (buttonText) buttonText.textContent = button.getAttribute('data-label-soldout') || 'Sold out';
        }
      }
      // Scroll gallery to the variant image
      if (variant.featured_media) {
        var media = document.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        var track = media && media.closest('.product-gallery__track');
        if (media && track) track.scrollTo({ left: media.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      // Keep URL shareable
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (el) {
      el.addEventListener('change', onChange);
    });
  }

  document.querySelectorAll('form[data-product-form]').forEach(initProductForm);

  /* ---------- Gallery arrows ---------- */

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (!arrow) return;
    var gallery = arrow.closest('.product-gallery');
    var track = gallery && gallery.querySelector('.product-gallery__track');
    if (!track) return;
    var dir = arrow.hasAttribute('data-gallery-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  });

  /* ---------- Collection sort ---------- */

  document.addEventListener('change', function (e) {
    var sort = e.target.closest('select[data-sort-by]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

})();
